module.exports = __webpack_public_path__ + "static/img/KW.5a284f45.png";